import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PageAccessService {
  private readonly STORAGE_KEY = 'mostAccessedPages';
  private readonly MAX_PAGES = 6;

  constructor() {}

  addPageAccess(route: string, pageInfo: any) {
    try {
      let pages = this.getMostAccessedPages();
      const existingIndex = pages.findIndex((p: any) => p.route === route);

      if (existingIndex !== -1) {
        const page = { ...pages[existingIndex] };
        page.count = (page.count || 0) + 1;
        pages.splice(existingIndex, 1);
        pages.unshift(page);
      } else {
        pages.unshift({
          ...pageInfo,
          count: 1
        });
      }

      pages = pages.slice(0, this.MAX_PAGES);
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(pages));

      return pages;
    } catch (error) {
      return [];
    }
  }

  getMostAccessedPages() {
    try {
      const stored = localStorage.getItem(this.STORAGE_KEY);
      if (!stored) return [];
      
      const pages = JSON.parse(stored);
      if (!Array.isArray(pages)) return [];
      
      return pages;
    } catch (error) {
      console.error('Error getting most accessed pages:', error);
      return [];
    }
  }

  setMostAccessedPages(pages: any[]): void {
    try {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(pages));
    } catch (error) {
      console.error('Error setting most accessed pages:', error);
    }
  }

  clearAccessHistory() {
    localStorage.removeItem(this.STORAGE_KEY);
  }
}